export default {
  //API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://stark-mesa-43211.herokuapp.com/api',
}
